module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/191DO0x/media/FC-9798886939996.jpg?1718046539699",
      "alt": "This image is the cover for the book The Three Americans"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Three Americans\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("It is 1917. Janet Defoe never planned for the day German biplanes would appear and blow her world away. With her French home in shambles and only a derringer for protection, she finds her way across the war-torn town. She meets a band of tattered French survivors and together they form a plan for escape. Before they can reach their rendezvous point, they are overtaken by German guards. With blood on her hands, Janet sets out on her own. She doesn’t know what lies around the corner, perhaps death perhaps another chance at life.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Meanwhile, three Americans named Douglas, Teddy, and Burke, fresh from the trenches, pursue the Germans across the scorched French landscape. They have one goal and that is to kill the enemy. When they are overcome and taken prisoner, they take the matter of their rescue into their own hands. Ultimately, Douglas and Teddy make away with German guard uniforms and return with rifles to retrieve their companion. Upon their escape, they run into a French youth who was drafted by the German army named Jeannot. Together they patrol the town in search of food, ammunition, and shelter against the German presence.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Bianca, a French girl who has lost everything to the Germans, soon finds her way into the lives of the four soldiers… and young Teddy’s heart. With their band complete, the only thing for the five of them to do is survive the occupation. Days pass, perhaps weeks. Jeannot reveals a shocking secret to the others. Planes appear in the sky, but they are not German planes. The liberation of Beau Chateau is at hand. Janet and the three Americans hit the streets in their “grays” and clear a path for the allies with their rifles and grenades. The war for them is about to be over.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Charlene Gadient\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "0cm",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif",
      "color": "black"
    }
  }, [_vm._v("Charlene Gadient was born in 1985, in Kansas City, Missouri. She is the second oldest of six children. She was raised and home-schooled in a two-story farmhouse in Dade County, Missouri. She moved to Springfield, Missouri, when she was seventeen, where she met Ray, the love of her life. They were joined in holy matrimony and continue to live happily together with their three children not far from her childhood home.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0